/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedUsersDto } from '../../models/paginated-users-dto';

export interface SuperadminControllerListUsers$Params {
  search?: string;
  subscriptionGroup?: 'free' | 'inactive' | 'stripe';
  tag?: string;
  page?: number;
  pageSize?: number;
}

export function superadminControllerListUsers(http: HttpClient, rootUrl: string, params?: SuperadminControllerListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedUsersDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerListUsers.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('subscriptionGroup', params.subscriptionGroup, {});
    rb.query('tag', params.tag, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedUsersDto>;
    })
  );
}

superadminControllerListUsers.PATH = '/superadmin/users';
